// extracted by mini-css-extract-plugin
module.exports = {"link":"yz_gn"};